import { reactive } from "#imports";
export const TeleportMountedNames = reactive({});
